import { useState, useEffect } from 'react'

import api from 'common/api'

export const useOrderCancelStatus = (orderListData) => {
  const [orderCancelData, setOrderCancelData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  // 주문 취소 가능여부 API 호출
  const getOrderCancelData = async (orderNo) => {
    try {
      setIsLoading(true)
      setError(null)

      const response = await api.get(`/payment/v2/order/cancel/check/${orderNo}`)

      if (response.data.meta.code !== 200) {
        throw new Error(response.data.meta.message)
      }

      return response.data.data
    } catch (error) {
      setError(error)
      console.error('Error in getOrderCancelData:', error)
      return false
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (orderListData && orderListData.length > 0) {
      const fetchAllOrderStatuses = async () => {
        const results = await Promise.all(
          orderListData.map(async (order) => ({
            orderNo: order.orderNo,
            cancelStatus: await getOrderCancelData(order.orderNo)
          }))
        )
        setOrderCancelData(results)
      }

      fetchAllOrderStatuses()
    }
  }, [orderListData])

  return {
    orderCancelData,
    isLoading,
    error,
    //refetch: getOrderCancelData
    getOrderCancelData
  }
}
